<mat-form-field [style.width]="width">
  <mat-label class="font-semibold">
    {{ label | translate }}
    <small *ngIf="required" class="text-gray-400">
      ({{ 'shared:required' | translate }})
    </small>
  </mat-label>
  <mat-select
    [(ngModel)]="country"
    (ngModelChange)="valueChanged.next(country)"
    [disabled]="disabled"
    [required]="required">
    <mat-select-trigger>
      <div class="flex items-center" *ngIf="country">
        <img
          class="object-cover w-6 h-6 rounded-full mr-2"
          src="https://flagcdn.com/{{ country.iso }}.svg"
          width="36"
          height="27"
          [alt]="country.iso"
          loading="lazy" />
        {{ country.name }}
      </div>
    </mat-select-trigger>
    <mat-option [value]="item" *ngFor="let item of countries">
      <div class="flex items-center">
        <img
          class="object-cover w-6 h-6 rounded-full mr-2"
          src="https://flagcdn.com/{{ item.iso }}.svg"
          width="36"
          height="27"
          [alt]="item.iso"
          loading="lazy" />
        {{ item.name }}
      </div>
    </mat-option>
  </mat-select>
  <mat-error *ngIf="!country && required">
    {{ 'shared:isRequired' | translate }}
  </mat-error>
</mat-form-field>
<mat-icon
  *ngIf="isOnboarding"
  class="fa-regular fa-question-circle ml-4"
  matTooltip="{{ 'createCompany:missingCountry' | translate }}"></mat-icon>
